import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.push.js";
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/customize.jpg';
const _withScopeId = n => (_pushScopeId("data-v-50e7df95"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "home-content"
};
import { reactive, onMounted } from 'vue';
import BannerSwiper from '@/components/BannerSwiper';
import LiveCard from '@/components/LiveCard';
import CourseCard from '@/components/HomeCourseCard';
import Advertising from '@/components/Advertising';
import TitleCard from './TitleCard';
import CourseClassification from './CourseClassification';
import ProgectNotice from './ProgectNotice';
import { postHomeCourse, postBanner } from '@/api/home';
import router from '@/router';
export default {
  __name: 'index',
  setup(__props) {
    const state = reactive({
      noticeData: [],
      LiveCourse: [],
      goodCourse: [],
      abilityData: [],
      bannerImgs: [],
      adImgs: null,
      LivingTitle: '',
      noticeTitle: '',
      goodTitle: ''
    });
    function fetchHomeCourse() {
      postHomeCourse().then(res => {
        if (res.success) {
          var _res$data$marketClass, _res$data$marketClass2, _res$data$marketClass3, _res$data$marketClass4, _res$data$marketClass5, _res$data$marketClass6, _res$data$marketClass7, _res$data$marketClass8, _res$data$marketClass9, _res$data$marketClass10, _res$data$marketClass11, _res$data$marketClass12;
          state.abilityData = res.data.abilityClass;
          state.LiveCourse = ((_res$data$marketClass = res.data.marketClass) === null || _res$data$marketClass === void 0 ? void 0 : (_res$data$marketClass2 = _res$data$marketClass.find(elem => elem.code === 'jjkk')) === null || _res$data$marketClass2 === void 0 ? void 0 : _res$data$marketClass2.courseInfo) || [];
          state.LivingTitle = ((_res$data$marketClass3 = res.data.marketClass) === null || _res$data$marketClass3 === void 0 ? void 0 : (_res$data$marketClass4 = _res$data$marketClass3.find(elem => elem.code === 'jjkk')) === null || _res$data$marketClass4 === void 0 ? void 0 : _res$data$marketClass4.name) || '暂无专题';
          state.goodCourse = ((_res$data$marketClass5 = res.data.marketClass) === null || _res$data$marketClass5 === void 0 ? void 0 : (_res$data$marketClass6 = _res$data$marketClass5.find(elem => elem.code === 'jpk')) === null || _res$data$marketClass6 === void 0 ? void 0 : _res$data$marketClass6.courseInfo) || [];
          state.goodTitle = ((_res$data$marketClass7 = res.data.marketClass) === null || _res$data$marketClass7 === void 0 ? void 0 : (_res$data$marketClass8 = _res$data$marketClass7.find(elem => elem.code === 'jpk')) === null || _res$data$marketClass8 === void 0 ? void 0 : _res$data$marketClass8.name) || '暂无专题';
          state.noticeData = ((_res$data$marketClass9 = res.data.marketClass) === null || _res$data$marketClass9 === void 0 ? void 0 : (_res$data$marketClass10 = _res$data$marketClass9.find(elem => elem.code === 'xmtg')) === null || _res$data$marketClass10 === void 0 ? void 0 : _res$data$marketClass10.courseInfo) || [];
          state.noticeTitle = ((_res$data$marketClass11 = res.data.marketClass) === null || _res$data$marketClass11 === void 0 ? void 0 : (_res$data$marketClass12 = _res$data$marketClass11.find(elem => elem.code === 'xmtg')) === null || _res$data$marketClass12 === void 0 ? void 0 : _res$data$marketClass12.name) || '暂无专题';
        }
      });
    }
    function fetchBanner() {
      postBanner().then(res => {
        if (res.success) {
          const imgList = res.data;
          const publishImg = imgList.filter(ele => ele.publishStatus === '1');
          const banner = publishImg.filter(ele => ele.type === 'ROTATION');
          banner.sort(function (a, b) {
            if (a.sort === b.sort) {
              // 如果sort相同，按照创建时间的降序
              return b.exCreateTime - a.exCreateTime;
            } else {
              return a.sort - b.sort;
            }
          });
          state.bannerImgs = banner.slice(0, 5);
          const ad = publishImg.filter(ele => ele.type === 'ACTIVITY');
          ad.sort(function (a, b) {
            return b.exCreateTime - a.exCreateTime;
          });
          state.adImgs = ad[0];
        }
      });
    }
    const handleToCustomized = () => {
      router.push({
        path: '/customized'
      });
    };
    onMounted(() => {
      fetchBanner();
      fetchHomeCourse();
    });
    return (_ctx, _cache) => {
      const _component_el_empty = _resolveComponent("el-empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [state.adImgs ? (_openBlock(), _createBlock(_unref(Advertising), {
        key: 0,
        ad: state.adImgs
      }, null, 8, ["ad"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(_unref(BannerSwiper), {
        bannerImgs: state.bannerImgs
      }, null, 8, ["bannerImgs"]), _createVNode(_unref(CourseClassification), {
        abilityData: state.abilityData
      }, null, 8, ["abilityData"]), _createVNode(_unref(TitleCard), {
        courseTitle: state.LivingTitle,
        moreText: '更多课程',
        coursePlayType: '1'
      }, null, 8, ["courseTitle"]), _createVNode(_unref(LiveCard), {
        courseData: state.LiveCourse
      }, null, 8, ["courseData"]), state.LiveCourse.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 0,
        description: "暂无课程"
      })) : _createCommentVNode("", true), _createVNode(_unref(TitleCard), {
        courseTitle: state.goodTitle,
        moreText: '更多好课',
        coursePlayType: '0'
      }, null, 8, ["courseTitle"]), _createVNode(_unref(CourseCard), {
        courseData: state.goodCourse
      }, null, 8, ["courseData"]), state.goodCourse.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        description: "暂无课程"
      })) : _createCommentVNode("", true), _createVNode(_unref(TitleCard), {
        courseTitle: state.noticeTitle,
        moreText: '更多通告',
        coursePlayType: '1'
      }, null, 8, ["courseTitle"]), _createVNode(_unref(ProgectNotice), {
        noticeData: state.noticeData
      }, null, 8, ["noticeData"]), state.noticeData.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 2,
        description: "暂无课程"
      })) : _createCommentVNode("", true), _createVNode(_unref(TitleCard), {
        courseTitle: '定制化咨询',
        showIcon: false
      }), _createElementVNode("img", {
        class: "customized",
        src: _imports_0,
        onClick: handleToCustomized
      })])]);
    };
  }
};